module.exports = require("react-redux");


//////////////////
// WEBPACK FOOTER
// external "react-redux"
// module id = 542
// module chunks = 0